/**
 * Topic detail component
 */
import 'rxjs/add/operator/switchMap';

import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { Programme } from '../types/programme';
import { Topic } from '../types/topic';


@Component({
  selector: 'topic-detail',
  templateUrl: './topic-detail.component.html',
  styleUrls: ['./topic-detail.component.css'],
  providers: [VoxPopService],
})

export class TopicDetailComponent implements OnInit {
  @Input() topic: Topic;
  @Input() programmes: Programme[];
  @Input() inserting: boolean;
  @Input() type_id: number;
  @Output() closeDetail: EventEmitter<any> = new EventEmitter();
  errorMessage: string;
  editable = false;
  private topic_active = false;
  private defaultMaxDuration = 30;

  constructor(
    private voxPopService: VoxPopService,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) { return; }

    if (!this.programmes || this.programmes.length < 1) {
      this.programmes = <Programme[]>[{ "name": "-- not set --" }];
      this.voxPopService.myActiveProgrammes().subscribe(
        programmes => {
          this.programmes = programmes;
          if (this.inserting && this.programmes.length) {
            this.topic.programme_id = this.programmes[0].id;
          }
        },
        error => this.errorMessage = <any>error,
      );
    } else {
      console.log("programmes is: " + this.programmes.length + " elements, " + JSON.stringify(this.programmes, null, 2));
    }

    if (this.inserting) {
      this.topic = new Topic();

      var maxDuration = this.programmes[0].default_recording_duration ?? this.defaultMaxDuration;
      if (maxDuration <= 0) {
        maxDuration = this.defaultMaxDuration;
      }
      this.topic.max_duration = maxDuration;

      if (this.programmes.length) {
        this.topic.programme_id = this.programmes[0].id;
      }
      this.editable = true;
      this.topic.type_id = this.type_id;
    } else {
      console.log('Getting topic detail.');
      this.route.params
        .switchMap((params: Params) => this.voxPopService.getTopic(+params['topicid']))
        .subscribe(
          topic => this.setTopic(topic),
          error => this.errorMessage = <any>error,
        );
    }
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   for (let propName of Object.keys(changes)) {
  //     console.log('Property ' + propName + ' changed');
  //     // switch (propName) {
  //     //   case 'inHub':
  //     //     this.switchHub();
  //     //     break;
  //     // }
  //   }
  // }

  CanAdminister(): boolean {
    if (this.topic.programme_id < 1) {
      return ProfileService.CanAdminister();
    }
    return ProfileService.CanAdministerProgramme(this.topic.programme_id);
  }

  setTopic(topic: Topic) {
    console.log('Loaded topic ' + topic.topic + '(' + topic.id + ')');
    this.topic = topic;
    this.topic_active = topic.active;
    // AppComponent.SetTitle(topic.topic + ' (' + topic.id + ')')
  }

  goBack(): void {
    this.location.back();
  }

  cancel(): void {
    this.editable = false;
    this.closeDetail.emit(null);
  }

  save(): void {
    if (<any>this.topic.active) { this.topic.active = true; }
    if (!<any>this.topic.active) { this.topic.active = false; }
    this.topic.programme_id = Number(this.topic.programme_id);
    this.programmes.forEach(programme => {
      if (programme.id === this.topic.programme_id) {
        this.topic.programme_key = programme.short_name;
        this.topic.programme_name = programme.name;
      }
    });

    if (this.inserting) {
      console.log('Creating new topic: ' + this.topic.topic + '(' + this.topic.short_name + ')');
      if (this.topic.active) {
        // This could be better addressed as a trigger
        this.topic.publication_time = new Date();
        this.topic_active = true;
      } else {
        this.topic_active = false;
      }
      this.voxPopService.createTopic(this.topic)
        .subscribe(
          topic => {
            this.setTopic(topic);
            this.editable = false;
            this.inserting = false;
            this.closeDetail.emit(null);
          },
          error => this.errorMessage = <any>error,
        );
    } else {
      if (this.topic.active && !this.topic_active) {
        this.topic.publication_time = new Date();
        this.topic_active = true;
      } else if (!this.topic.active) {
        this.topic_active = false;
      }
      this.voxPopService.updateTopic(this.topic)
        .subscribe(() => this.editable = false);
    }
  }

  edit(): void {
    this.editable = true;
    console.log("programmes is: " + JSON.stringify(this.programmes, null, 2));
  }

}
